import client from '../_helper/client'
import { stringify as querystring } from '../_helper/query'

export const userService = {
    resetPassword,
    hasResetCapability,
    setPassword
}

function resetPassword (email) {
    const qs = querystring({email: email})
    return client.get(`/api/v2/reset?${qs}`)
}

function hasResetCapability () {
    return client.get('/api/v2/reset')
}

function setPassword (password) {
    return client.put('/api/v2/reset', {password: password})
}
